import { Container, Row, Col, Button } from 'react-bootstrap';
import { Helmet } from 'react-helmet';
import styled from "styled-components"

import Footer from '../components/Layout/Footer';

import MobileNavLogo from '../assets/images/Secondary Logo - Vertical - Color.png';

import '../components/GlobalStyle.css';
import '../components/Backgrounds/Backgrounds.css';

import { FadeLoad, FadeLoadDelay } from '../components/styled/Motion.styled';


const FormCard = styled.div`
    box-shadow: 4px 4px 20px rgba(0, 0, 0, .25);
    border-radius: .5rem;
    padding: 1rem;
    background-color: #ffffff;
`


const AnthonyContact = () => {
    return (
        <>
            <Helmet>
                <meta charSet="utf-8" />
                <title>Anthony Gennette | Best Payment Solutions</title>
                <link rel="canonical" href="https://bestpayment.solutions/anthony-gennette" />
            </Helmet>
            <Container fluid className='text-center'>
                <img src={MobileNavLogo} alt="Best Payment Solutions" width='160px' />
            </Container>
            <Container fluid className='vh-75 py-5 circle-bg-1 bg-cream'>
                <Row className='justify-content-evenly'>
                    <Col lg={4} md className='mt-30-vh text-center'>
                        <FadeLoad>
                            <h2 className='fw-bold fs-24 color-sky-tint-1' id='Anthony-Gennette'>It's nice to meet you!</h2>
                            <h1 className='fs-60'>
                                Let's talk about solutions
                            </h1>
                            {/* <p>
                                Ready to take the next step? Want to see a demo of what we can do for you?
                            </p> */}
                        </FadeLoad>
                    </Col>
                    <Col lg={4} md className='mt-4 mt-md-0'>
                        <iframe className="pipedriveWebForms form-iframe" src="https://webforms.pipedrive.com/f/2TVHQJ6LAPqDEKdqXLd1F4G7NuaiZWCITLGm81AYRNwnaUes0BEjLTsQ22g1tm8KL">
                            <script src="https://webforms.pipedrive.com/f/loader"></script>
                        </iframe>
                    </Col>
                </Row>
            </Container>
            <Footer />
        </>
    );
}

export default AnthonyContact;